import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useBatchedPaginatedQuery } from './use-batched-paginated-query';

export function useStaff(opts: {
  viewPage: number;
  viewPageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}) {
  const viewPageSize = opts.viewPageSize ?? 10;
  return useBatchedPaginatedQuery(
    queryKeys.users.staff(opts.sortBy, opts.sortOrder),
    (fetchOpts) =>
      api.listStaff({
        page: fetchOpts.page,
        limit: fetchOpts.limit,
        sortBy: opts.sortBy,
        sortOrder: opts.sortOrder,
      }),
    { viewPage: opts.viewPage, viewPageSize },
  );
}
